import { render, staticRenderFns } from "./delete-file-modal.vue?vue&type=template&id=7ca31695"
import script from "./delete-file-modal.ts?vue&type=script&lang=ts&external"
export * from "./delete-file-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./delete-file-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ca31695')) {
      api.createRecord('7ca31695', component.options)
    } else {
      api.reload('7ca31695', component.options)
    }
    module.hot.accept("./delete-file-modal.vue?vue&type=template&id=7ca31695", function () {
      api.rerender('7ca31695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/delete-file-modal/delete-file-modal.vue"
export default component.exports